import classNames from 'classnames';
import { t } from 'ttag';

import HeartIcon from '@svg/heart.svg';
import HeartFilledIcon from '@svg/heart2.svg';
import { prepareFavouriteCount } from '@utils/favourites';
import { Button } from '@ui/Button';

import s from './ProductFavoritesToggle.sss';

interface Props {
  className?: string,
  likes: number,
  isLiked: boolean,
  isDetailed?: boolean,
  onToggle: (isLiked: boolean) => void,
}

export const ProductFavoritesToggle: React.FC<Props> = ({
  className,
  likes,
  isLiked,
  isDetailed,
  onToggle,
}) => {
  const Icon = isLiked ? HeartFilledIcon : HeartIcon;

  const handleToogle = () => {
    onToggle(!isLiked);
  };

  return (
    (
      <div className={classNames(s.root, className)}>
        <Button
          className={s.button}
          theme="text"
          onClick={handleToogle}
        >
          {isDetailed ? (
            <>
              <span className={s.count}>
                {prepareFavouriteCount(likes, isLiked)}
              </span>

              <Icon
                className={s.icon}
                width="24"
                height="24"
              />

              <span className={s.caption}>
                {isLiked ? t`Видалити з обраного` : t`В обране`}
              </span>
            </>
          ) : (
            <>
              <span className={s.count}>
                {prepareFavouriteCount(likes, isLiked)}
              </span>

              <Icon
                className={s.icon}
                width="24"
                height="24"
              />
            </>
          )}
        </Button>
      </div>
    )
  );
};
